import { BrandingTheme } from '@torticity/types'

import { Theme } from './theme'

const config: Theme = {
  key: BrandingTheme.BLUE,
  label: 'blue',
  tokens: {
    'primary-button': [
      'tw-bg-blue-600',
      'hover:tw-bg-blue-900',
      'tw-text-white',
      'tw-py-4',
      'tw-px-6',
      'tw-rounded-full',
      'tw-font-bold',
      'tw-text-md',
      'tw-cursor-pointer',
      'disabled:tw-opacity-50',
      'disabled:tw-cursor-not-allowed',
    ],
    'secondary-button': [
      'tw-border-blue-200',
      'tw-bg-blue-100',
      'tw-text-blue-950',
      'hover:tw-bg-blue-300',
      'active:tw-bg-blue-400',
      'tw-cursor-pointer',
    ],
    'tertiary-button': [
      'tw-bg-white',
      'tw-border-2',
      'tw-border-blue-600',
      'tw-text-blue-900',
      'hover:tw-bg-blue-50',
      'active:tw-bg-blue-100',
      'tw-rounded-full',
      'tw-font-semibold',
      'tw-text-md',
      'tw-py-2',
      'tw-px-6',
      'tw-cursor-pointer',
    ],
    'primary-text': ['tw-text-blue-700'],
    'header-nav': ['!tw-bg-blue-900'],
    'header-active-item': [
      'tw-font-semibold',
      'tw-text-blue-800',
      'tw-bg-white',
      'tw-bg-opacity-80',
    ],
    'loading-spinner': ['tw-fill-blue-600'],
    'primary-icon': ['tw-fill-blue-500', 'tw-text-blue-500'],
    'secondary-icon': [
      'tw-text-blue-800',
      'tw-bg-blue-100',
      'tw-flex',
      'tw-flex-shrink-0',
      'tw-content-center',
      'tw-items-center',
      'tw-justify-center',
      'tw-rounded-full',
    ],
    'tertiary-icon': ['tw-fill-blue-800', 'tw-text-blue-700'],
    'auth-footer': ['tw-text-white', '!tw-bg-blue-800'],
    'secondary-text': ['tw-text-blue-500'],
    'linear-gradient': ['tw-to-blue-500', 'tw-from-blue-900'],
    'light-linear-gradient': ['tw-bg-blue-500'],
    'dark-linear-gradient': ['tw-bg-blue-900'],
    'light-background': ['tw-bg-blue-50'],
    'dark-background': ['tw-bg-blue-700'],
    'tracker-dots': ['tw-border-blue-500', 'tw-bg-blue-50'],
    'active-tracker-dot': ['tw-bg-blue-800', 'tw-rounded-full'],
    'action-flow': ['tw-bg-blue-600'],
    'action-flow-button': ['tw-bg-blue-600', 'hover:tw-bg-blue-900'],
    'mobile-tracker-line': ['tw-bg-blue-500'],
    'bottom-nav-active-bar': ['tw-bg-blue-700'],
    'primary-border': ['tw-border-blue-500'],
    'dark-border': ['tw-border-blue-700'],
    'hover-background': ['hover:tw-bg-blue-50'],
    'hover-border': ['hover:tw-border-blue-500'],
  },
}

export default config
